import {pressReleaseBodyElementId} from '@press-release-ui/press-release-body/const';
import {useEffect, useRef} from 'react';

export const useApplyTableAnimationEffect = (isOldRelease: boolean) => {
  const hasApplied = useRef(false);

  const apply = () => {
    if (hasApplied.current) return;

    const id = `#${pressReleaseBodyElementId}`;
    const container = document.querySelector(id);

    if (container === null) return;

    hasApplied.current = true;

    // 画面に表示されたらアニメーションを実行する
    for (const element of container.querySelectorAll('.swiperIcon')) {
      const observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              entry.target.classList.add('onSwipe');
            }
          }
        },
        {threshold: 0.5},
      );
      observer.observe(element);
    }

    // html table は旧リリースの場合は.tableWrapperでラップされている、新リリースの場合に.pr-tableでラップされている
    // ラップの目的は指スワイプのアニメーションを適用するため
    for (const element of container.querySelectorAll(
      isOldRelease ? '.tableWrapper' : '.pr-table',
    )) {
      element.addEventListener('scroll', () => {
        element.previousElementSibling?.classList.add('onFadeOut');
      });
    }
  };

  useEffect(() => {
    apply();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
